import { render, staticRenderFns } from "./cardtravelerdependent.vue?vue&type=template&id=27ed277a&scoped=true&"
import script from "./cardtravelerdependent.vue?vue&type=script&lang=js&"
export * from "./cardtravelerdependent.vue?vue&type=script&lang=js&"
import style0 from "./cardtravelerdependent.vue?vue&type=style&index=0&id=27ed277a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed277a",
  null
  
)

export default component.exports